module.exports = __webpack_public_path__ + "media/images/emblems/Ballaigues-coat_of_arms-d390656a239c53f808d9ac22aaebb6c4.svg";